import { wrap } from 'src/packages/mobx-di/wrap';

import type { MainDirectoryService } from 'src/services/directory-service/main-directory-service';
import type { TControlView } from 'src/services/directory-service/types';

import { FormControl } from '../directory-form-sidebar/features/form/form-control';

type Props = {
  directory: MainDirectoryService;
  fieldViews: TControlView[];
};

export const GeneralControls = wrap<Props>(function GeneralControls({ directory, fieldViews }) {
  return (
    <>
      {fieldViews.map((controlView) => {
        return (
          <FormControl
            key={controlView.attrName}
            withLabel={false}
            controlView={controlView}
            optionsService={directory.optionsService}
            data={directory.generalDataValues}
            required={directory.view.required.includes(controlView.fieldId)}
            onChange={directory.onGeneralDataValueChange}
            onBlur={directory.onGeneralControlBlur}
          />
        );
      })}
    </>
  );
});
